import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const LightsOffIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M4.63639 20.4707L20.6701 4.43686L19.3973 3.16406L16.5538 6.0076C14.9975 5.3288 13.2423 4.92679 11.5601 4.84015C10.5001 7.22015 9.88006 9.78015 9.88006 12.0002C9.88006 12.2182 9.88604 12.4395 9.89783 12.6636L6.92132 15.6402H2.56006V17.6802H4.88134L3.36361 19.1979L4.63639 20.4707ZM15.0719 7.4895C14.3194 7.24665 13.556 7.08589 12.8601 7.00015C12.4222 8.09488 12.0801 9.38137 11.9273 10.6341L15.0719 7.4895ZM12.8601 17.0002C12.6521 16.4802 12.4657 15.9169 12.311 15.3346L10.7134 16.9322C10.9507 17.6818 11.2346 18.4294 11.5601 19.1602C16.2201 18.9202 21.4401 16.2602 21.4401 12.0002C21.4401 10.4443 20.7438 9.10186 19.6328 8.01279L18.3054 9.34015C18.9978 10.0508 19.4401 10.9317 19.4401 12.0002C19.4401 15.1402 15.6201 16.6602 12.8601 17.0002ZM2.56006 6.24015H8.12006V8.28015H2.56006V6.24015ZM2.56006 10.9402H8.12006V12.9802H2.56006V10.9402Z"
      />
    </SvgIcon>
  );
});
